export enum ArrowDirection {
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
  Left = 'left',
}

export enum ArrowPosition {
  Before = 'before',
  After = 'after',
}
